﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {CreateOrSelectResidencyModel} from "../components/CreateOrSelectResidencyComponent";
import {ZoneId} from "../nominalTypes/ZoneId";
import {ResidencyResult} from "../types/ResidencyResult";

export default function isZoneChange(model: CreateOrSelectResidencyModel, residencies: ResidencyResult[] | undefined, zoneIdWarning: ZoneId | undefined): boolean {
	const newZoneId = model.residencyId === "create" ? model.arguments.zoneId : residencies?.find(x => x.id === model.residencyId)?.zoneId;
	return !isNullOrEmpty(zoneIdWarning) && !isNullOrEmpty(newZoneId) && newZoneId !== zoneIdWarning;
}
